if (!customElements.get('product-card')) {
  customElements.define('product-card', class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelectorAll('[data-swatches] .product-card__swatch');
      this.mainImage = this.querySelector('[data-main-image]');
      
      this.init();
    }

    init() {
      this.swatches.forEach(swatch => {
        swatch.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.updateImage(swatch);
        });

        swatch.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            this.updateImage(swatch);
          }
        });
      });
    }

    updateImage(selectedSwatch) {
      const newImage = selectedSwatch.getAttribute('data-image');
      if (!newImage || !this.mainImage) return;

      this.swatches.forEach(s => s.classList.remove('is-active'));
      selectedSwatch.classList.add('is-active');

      const base = newImage.replace(/[?&]width=\d+/, '');
      const sep = base.includes('?') ? '&' : '?';
      this.mainImage.src = base + sep + 'width=600';
      this.mainImage.srcset = [400, 600, 800]
        .map(w => `${base}${sep}width=${w} ${w}w`)
        .join(', ');
    }
  });
}
